import request from './request';

export const fetchNotationHeader = () =>
  request({
    method: 'GET',
    url: '/communication/notation/header',
    protectedRoute: true,
    newApi: true
  });

export const fetchNotationHeaderCompare = () =>
  request({
    method: 'GET',
    url: '/communication/notation/compare/header',
    protectedRoute: true,
    newApi: true
  });

export const fetchNotationRaw = () =>
  request({
    method: 'GET',
    url: `/communication/notation/raw`,
    protectedRoute: true,
    newApi: true
  });

export const fetchNotationWxr = (options) =>
  request({
    method: 'GET',
    url: `/communication/notation/wxr/data?no_page${
      !options.type || options.type == 'is_primeur'
        ? '&is_primeur=true'
        : '&is_livrable=true'
    }${options.vintage ? '&vintage=' + options.vintage : ''}`,
    protectedRoute: true,
    newApi: true
  });

export const fetchNotationCompare = (options) =>
  request({
    method: 'GET',
    url: `/communication/notation/compare/data?no_page${
      options.rank && options.rank.length > 0
        ? '&classements=' + JSON.stringify(options.rank)
        : ''
    }${
      options.appellation && options.appellation.length > 0
        ? '&appelations=' + JSON.stringify(options.appellation)
        : ''
    }`,
    protectedRoute: true,
    newApi: true
  });

export const fetchJournalistBonus = () =>
  request({
    method: 'GET',
    url: `/api/v1/clients/me/journalist_bonus/?no_page`,
    protectedRoute: true,
    newApi: false
  });

export const insertJournalistBonus = (data) =>
  request({
    method: 'POST',
    url: `/api/v1/clients/me/journalist_bonus/`,
    protectedRoute: true,
    data: data,
    newApi: false
  });
